import { useContext } from "react";
import BlaboAuthContext from "./components/BlaboAuthContext";

export default function(){
    const value = useContext(BlaboAuthContext);

    return value;
}